import React from 'react';
import { motion } from 'framer-motion';
import { Droplets } from 'lucide-react';
import { portfolioData } from '../data/mock';

const TerrariumSection = () => {
  const { hobbies } = portfolioData;
  const { terrarium } = hobbies;
  
  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 md:px-12 lg:px-24">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="text-center mb-2">
          <h2 className="text-2xl sm:text-3xl md:text-4xl" style={{ fontFamily: 'Cinzel, serif', color: 'rgba(235, 240, 250, 0.95)', fontWeight: 400 }}>{terrarium.heading}</h2>
        </motion.div>
        
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} className="text-center mb-8 sm:mb-10 md:mb-12" style={{ fontFamily: 'DM Mono, monospace', color: 'rgba(150, 170, 200, 0.7)', fontSize: '0.85rem' }}>
          {terrarium.subtitle}
        </motion.p>
        
        <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
          <motion.div 
            initial={{ opacity: 0, x: -40 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            viewport={{ once: true }} 
            transition={{ duration: 0.8 }}
            whileHover={{ scale: 1.02, y: -4 }}
            className="glass-panel p-6 sm:p-8 relative overflow-hidden"
          >
            <div className="absolute inset-0 pointer-events-none overflow-hidden">
              {[...Array(10)].map((_, i) => (
                <motion.div key={i} className="absolute w-1 h-1 rounded-full" style={{ left: `${10 + Math.random() * 80}%`, bottom: '-10px', background: 'rgba(180, 200, 220, 0.4)' }}
                  animate={{ y: [-10, -300], opacity: [0.4, 0] }} transition={{ duration: 4 + Math.random() * 2, repeat: Infinity, delay: i * 0.5, ease: 'linear' }} />
              ))}
            </div>
            <h3 className="text-lg sm:text-xl mb-4 sm:mb-6" style={{ fontFamily: 'Cinzel, serif', fontStyle: 'italic', color: 'rgba(235, 240, 250, 0.95)' }}>{terrarium.terrariumTitle}</h3>
            {terrarium.terrariumContent.split('\n\n').map((para, i) => (
              <p key={i} className="mb-3 sm:mb-4 last:mb-0 text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>{para}</p>
            ))}
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 40 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            viewport={{ once: true }} 
            transition={{ duration: 0.8, delay: 0.2 }}
            whileHover={{ scale: 1.02, y: -4 }}
            className="glass-panel p-6 sm:p-8 relative overflow-hidden"
          >
            <div className="absolute inset-0 pointer-events-none overflow-hidden opacity-30">
              {[...Array(3)].map((_, i) => (
                <motion.div key={i} className="absolute" style={{ top: `${30 + i * 20}%`, left: '50%' }} animate={{ x: [-30, 30] }} transition={{ duration: 4 + i, repeat: Infinity, repeatType: 'reverse', ease: 'easeInOut' }}>
                  <Droplets className="w-3 h-3 sm:w-4 sm:h-4" style={{ color: 'rgba(180, 200, 230, 0.5)' }} />
                </motion.div>
              ))}
            </div>
            <h3 className="text-lg sm:text-xl mb-4 sm:mb-6" style={{ fontFamily: 'Cinzel, serif', fontStyle: 'italic', color: 'rgba(235, 240, 250, 0.95)' }}>{terrarium.aquariumTitle}</h3>
            {terrarium.aquariumContent.split('\n\n').map((para, i) => (
              <p key={i} className="mb-3 sm:mb-4 last:mb-0 text-sm sm:text-base" style={{ fontFamily: 'EB Garamond, serif', color: 'rgba(220, 230, 245, 0.9)', lineHeight: '1.85' }}>{para}</p>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TerrariumSection;